import { Model } from "../../classes/mvc/Model";

export class ModelPagination extends Model { }